import { h } from 'preact';
import { MultistepForm } from './multistep/form';
import { listenToItemsAdded } from './utils/local-storage';
import { attachModalTrigger } from '../theme/modal/attachTrigger';
import { confirmRemoveGiftBox } from './remove/confirm-remove-gift-box';
import { openEditGiftBox } from './edit/open-drawer';
import { openEditGiftMessage, openComplimentaryMessage } from './utils/gift-message';
export const init = async ()=>{
    if (typeof window === 'undefined') return;
    if (init._initialized) return;
    init._initialized = true;
    let giftboxDefaultImage = null;
    let giftboxDefaultImageAlt = null;
    let giftboxProducts = null;
    let diyGiftboxProducts = null;
    try {
        var _container_querySelector;
        const container = document.querySelector('#js-cart-drawer');
        const raw = ((_container_querySelector = container === null || container === void 0 ? void 0 : container.querySelector('script[type="application/json"]')) === null || _container_querySelector === void 0 ? void 0 : _container_querySelector.textContent) || '{}';
        const parsed = JSON.parse(raw);
        if (parsed && parsed.giftWrapping) {
            if (parsed.giftWrapping.defaultImage) giftboxDefaultImage = parsed.giftWrapping.defaultImage;
            if (parsed.giftWrapping.defaultImageAlt != null) giftboxDefaultImageAlt = parsed.giftWrapping.defaultImageAlt;
            if (parsed.giftWrapping.products) giftboxProducts = parsed.giftWrapping.products;
            if (parsed.giftWrapping.diyProducts) diyGiftboxProducts = parsed.giftWrapping.diyProducts;
        }
    } catch (err) {
        giftboxDefaultImage = null;
        giftboxDefaultImageAlt = null;
        giftboxProducts = null;
        diyGiftboxProducts = null;
    }
    try {
        listenToItemsAdded();
    } catch (err) {
    // ignore
    }
    // Some templates still render a plain server-side button with
    // `data-modal-open='gift-wrapping-modal'`. Attach a capture-phase click
    // handler so those buttons will open the react modal too.
    attachModalTrigger({
        selector: '[data-modal-open]',
        id: 'gift-wrapping-modal',
        ariaLabel: 'Gift wrapping options',
        createVnode: ()=>h(MultistepForm, {
                targetEl: null,
                giftboxDefaultImage,
                giftboxDefaultImageAlt,
                giftboxProducts,
                diyGiftboxProducts
            })
    });
    // Delegate click on server-rendered ".gw-cart-item__remove" buttons so the
    // Liquid cart page can trigger the same remove-gift-box logic as the drawer.
    document.addEventListener('click', (evt)=>{
        var _evt_target;
        const target = (_evt_target = evt.target) === null || _evt_target === void 0 ? void 0 : _evt_target.closest('.js-remove-giftbox[data-gift-box-key]');
        if (!target) return;
        const itemKey = target.getAttribute('data-gift-box-key');
        if (!itemKey) return;
        evt.preventDefault();
        evt.stopPropagation();
        var _target_getAttribute;
        const itemImage = (_target_getAttribute = target.getAttribute('data-gift-box-image')) !== null && _target_getAttribute !== void 0 ? _target_getAttribute : undefined;
        confirmRemoveGiftBox(itemKey, itemImage);
    }, true);
    // Delegate click on server-rendered ".js-edit-giftbox" buttons so the
    // Liquid cart page can open the edit gift box drawer.
    document.addEventListener('click', (evt)=>{
        var _evt_target;
        const target = (_evt_target = evt.target) === null || _evt_target === void 0 ? void 0 : _evt_target.closest('.js-edit-giftbox[data-gift-box-key]');
        if (!target) return;
        const itemKey = target.getAttribute('data-gift-box-key');
        if (!itemKey) return;
        evt.preventDefault();
        evt.stopPropagation();
        openEditGiftBox(itemKey, {
            giftboxProducts,
            giftboxDefaultImage,
            diyGiftboxProducts
        });
    }, true);
    // Delegate click on server-rendered ".js-giftwrapping-edit-message" buttons
    // so the Liquid cart page can open the edit drawer focused on the gift message textarea.
    document.addEventListener('click', (evt)=>{
        var _evt_target;
        const target = (_evt_target = evt.target) === null || _evt_target === void 0 ? void 0 : _evt_target.closest('.js-giftwrapping-edit-message[data-item-key]');
        if (!target) return;
        const itemKey = target.getAttribute('data-item-key');
        if (!itemKey) return;
        evt.preventDefault();
        evt.stopPropagation();
        openEditGiftMessage(itemKey, {
            giftboxProducts,
            giftboxDefaultImage
        });
    }, true);
    // Delegate click on server-rendered ".js-giftwrapping-complimentary-message" buttons
    // so the Liquid cart page can open the modal focused on the complimentary message textarea.
    document.addEventListener('click', (evt)=>{
        var _evt_target;
        const target = (_evt_target = evt.target) === null || _evt_target === void 0 ? void 0 : _evt_target.closest('.js-giftwrapping-complimentary-message');
        if (!target) return;
        evt.preventDefault();
        evt.stopPropagation();
        openComplimentaryMessage({
            giftboxProducts,
            giftboxDefaultImage,
            diyGiftboxProducts
        });
    }, true);
};
export default init;
